import { RegisteredNpi } from '@/types/npi.ts';
import { PatientOacEnum } from '@/types/patient.ts';

export enum OrderStatus {
  EmptyAsPending = '',
  PendingOrder = 'Pending_Order',
  OrderFailedToPost = 'Order_Failed_To_Post',
  OrderRequiresSupport = 'Order_Requires_Support',
  ReadyToTransmit = 'Ready_To_Transmit',
  ReportFailedToPost = 'Report_Failed_To_Post',
  ReportRequiresSupport = 'Report_Requires_Support',
  SuccessfullyTransmitted = 'Successfully_Transmitted',
  OrderModified = 'Order_Modified'
}

export const ORDER_STATUS_NAME_MAPPING: Record<string, string> = {
  [OrderStatus.EmptyAsPending]: 'Pending Order',
  [OrderStatus.PendingOrder]: 'Pending Order',
  [OrderStatus.OrderFailedToPost]: 'Order: Failed To Post',
  [OrderStatus.OrderRequiresSupport]: 'Order: Failed To Post - Requires Support',
  [OrderStatus.ReadyToTransmit]: 'Ready To Transmit',
  [OrderStatus.ReportFailedToPost]: 'Report: Failed To Post',
  [OrderStatus.ReportRequiresSupport]: 'Report: Failed To Post - Requires Support',
  [OrderStatus.SuccessfullyTransmitted]: 'Successfully Transmitted',
  [OrderStatus.OrderModified]: 'Order Modified'
};

export const getOrderStatusName = (status?: string): string =>
  ORDER_STATUS_NAME_MAPPING[status ?? ''] ?? '';

export const OAC_OPTIONS = Object.values(PatientOacEnum).map((option) => ({
  label: option,
  value: option
}));

export const getReferringProviderName = ({
  referringProvider,
  isEHRIntegrated,
  referringPhysician
}: {
  referringProvider?: RegisteredNpi | null;
  isEHRIntegrated?: boolean;
  referringPhysician?: string | null;
}): string => {
  if (referringProvider) {
    const { firstName = '', lastName = '', NPI = '' } = referringProvider;
    const npiDetails = !isEHRIntegrated ? `(${NPI})` : '';
    return `${firstName} ${lastName} ${npiDetails}`.trim();
  }
  return referringPhysician ?? '';
};
